export default __webpack_public_path__ + "static/media/tape-help.b425387f.svg";